import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { from } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { apConfigsService } from 'src/app/shared/vive-api/ap-configs.service';
import { ApConfigDto } from 'src/app/shared/vive-api/vive-api-models';

@Component({
  selector: 'app-client-admin-accounting',
  templateUrl: './client-admin-accounting.component.html',
  styleUrls: ['./client-admin-accounting.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientAdminAccountingComponent {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private ToastService: ToastService,
    private Router: Router,
    private route: ActivatedRoute,
    private AuthService: AuthService
  ) {
    from(
      apConfigsService.findAllForClient({
        pathParams: { companyId: this.AuthService.getUserCompanyId() }
      })
    ).subscribe({
      next: ({ data: ApConfigs }) => {
        this.ApConfigs = ApConfigs;
        this._cdr.markForCheck();
      }
    });
  }

  ApConfigs?: ApConfigDto[];

  viewApVendors(id?: number) {
    if (!id) {
      throw this.ToastService.addErrorToast('Error', 'Missing AP Config ID.', {
        returnError: true
      });
    }

    this.Router.navigate([id], { relativeTo: this.route });
  }
}
